<template>
	<div>
		<div class="ModalPrompt" >
			<h1>Add org</h1>
		</div>
		<div class="ModalBody">
			<SimpleForm
				:autofocus="true"
				:onSubmit="onSubmit"
				:fields="[
					{
						label : 'Organisation name',
						name : 'name',
						autocomplete : 'company_name',
						autofocus : true,
						required : true,
					},
				]"
			/>
		</div>
	</div>
</template>

<script>

	import SimpleForm from '../components/SimpleForm';


	export default {
		components : {
			SimpleForm,
		},
		props : [
			'orgs',
		],
		methods: {
			onSubmit(payload){
				return this.$store
						.dispatch('auth/addOrg',payload)
						.then((org)=>{
							Event.$emit('modal-close');
						})
			}
		}
	}
</script>